import Swiper from 'swiper/dist/js/swiper'

export default {
  props: {
    selectedIndex: {
      default: undefined
    }
  },
  data () {
    return {
      isReady: false,
      swiperElement: false,
      swiper: null,
      swiperOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    }
  },
  methods: {
    mountSwiper () {
      if (this.isReady) {
        this.swiper = new Swiper(this.swiperElement ? this.swiperElement : this.$el, this.swiperOptions)
        if (this.selectedIndex) this.swiper.slideTo(this.selectedIndex, 0)
      }
    },
    slideToSwiper (index, speed) {
      this.swiper.slideTo(index, speed)
    },
    initSwiperFromEl (el) {
      this.$nextTick(() => {
        this.swiperElement = el
        this.isReady = true
      })
    }
    // updateSwiper () {
    //   this.swiper.update()
    // }
  },
  ready () {
    if (!this.swiper && this.isReady) {
      this.swiper = new Swiper(this.swiperElement ? this.swiperElement : this.$el, this.swiperOptions)
    }
  },
  mounted () {
    this.$nextTick(this.mountSwiper)
  },
  updated () {
    if (!this.swiper) {
      this.$nextTick(this.mountSwiper)
    }
  }
}
